/// <reference path="../../../../typings/index.d.ts" />
module App.Common.Directives {
	'use strict';

	export class PageHeading implements angular.IDirective {

		public template: string;

        public scope = {
            titleSecondary: '@',
            titlePrimary: '@'
		} as { [boundProperty: string]: string };

        constructor() {
            this.template =
				'<div class="row">' + 
				'<div class="page-heading col-lg-12">' +
					'<h1>{{titlePrimary}}</h1>' +
					'<h2 ng-if="titleSecondary">{{titleSecondary}}</h2>' +
				'</div>' +
			'</div>';
		}
	}
    
	angular
		.module('app.common.directives')
		.directive('pageHeading', () => { return new PageHeading(); });
}